import React from 'react';
import OpensInNewTab from './OpensInNewTab';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "MillTheGoddess R.",
      petType: "Cocoa's parent (Toy Poodle)",
      rating: 5,
      review: "Had a very pleasant experience with my 14 year old toy poodle, Cocoa. She had to end up having 14 teeth removed. I'm grateful that Dr Andrew and the team took such good care of her. They were prompt, kind, and transparent with pricing. I felt very at ease that she was in very good hands."
    },
    {
      name: "Bill Thomas",
      petType: "Canella's parent",
      rating: 5,
      review: "CHOMP PET DENTAL IS A GAME CHANGER! We had an absolutely incredible experience today. If you are looking for a place that genuinely cares and goes the extra mile for your pet's health, this is it. The staff is phenomenal, knowledgeable, and they operate with the utmost level of care."
    },
    {
      name: "Madison W.",
      petType: "Yorkie parent", 
      rating: 5,
      review: "I just want to say how impressed I was from the second I walked in. You can tell Dr. Heller truly cares. He went above and beyond to check on my pup after her cleaning and explained in great detail why he did what he did during the cleaning, showing me x rays and photos."
    },
    {
      name: "Gary Gluzman",
      petType: "Bella's parent (Yorkie)",
      rating: 5,
      review: "Bella's teeth have never looked better! Dr. Heller showed me her panoramic x-rays before anesthesia so I could actually see the issues at play and understand the plan. The whole team was calm, kind, and incredibly professional."
    }
  ];

  const renderStars = (rating: number) => {
    return [...Array(5)].map((_, index) => (
      <i
        key={index}
        className={`fas fa-star ${
          index < rating ? 'text-yellow-400' : 'text-gray-300'
        }`}
      ></i>
    ));
  };

  return (
    <section id="testimonials" className="bg-gradient-to-br from-soft-gray to-white py-12 lg:py-24 overflow-hidden relative">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-teal/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

      <div className="container-custom relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-brand-teal font-bold tracking-wider uppercase text-sm mb-3 block">
            Real Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-hellotend-brand-brown mb-6 font-nantes">
            Why pet parents love Chomp
          </h2>
          <div className="flex items-center justify-center gap-2 text-yellow-400 text-2xl mb-4">
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
          </div>
          <a 
            href="https://share.google/NSRxoEWFwHfHNUq3Q" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-gray-600 hover:text-brand-teal transition-colors"
          >
            <i className="fab fa-google text-lg"></i>
            <span className="underline decoration-gray-300 hover:decoration-brand-teal underline-offset-4">See all reviews on Google</span>
            <OpensInNewTab />
          </a>
        </div>
        
        <div className="grid gap-6 sm:gap-8 md:grid-cols-2 max-w-6xl mx-auto px-4">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="card hover-lift bg-white relative overflow-hidden"
            >
              {/* Quote icon */}
              <div className="absolute top-3 sm:top-4 right-3 sm:right-4 text-brand-teal opacity-20">
                <i className="fas fa-quote-right text-2xl sm:text-3xl lg:text-4xl"></i>
              </div>
              
              {/* Stars */}
              <div className="flex text-yellow-400 mb-3 sm:mb-4">
                {renderStars(testimonial.rating)}
              </div>
              
              {/* Review text */}
              <blockquote className="text-gray-700 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base lg:text-lg italic">
                "{testimonial.review}"
              </blockquote>
              
              {/* Author info */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-brand-teal to-teal-400 rounded-full flex items-center justify-center text-white font-bold text-base sm:text-lg flex-shrink-0">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-primary text-sm sm:text-base">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-600">{testimonial.petType}</div>
                </div>
              </div>
              
              {/* Background decoration */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-brand-teal to-teal-400"></div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;